"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _coreSc = require("@smooth-ui/core-sc");

var LinkItem = _coreSc.styled.li.withConfig({
  displayName: "NavLinkItem__LinkItem",
  componentId: "cujqek-0"
})(["display:inline-block;list-style-type:none;padding:0;margin-left:24px;margin-top:8px;margin-bottom:8px;", ""], (0, _coreSc.up)('md', (0, _coreSc.css)(["margin-top:0;margin-bottom:0;"])));

var _default = LinkItem;
exports["default"] = _default;